export * from './doc-remote-selection.js';
